module.exports = __webpack_public_path__ + "static/freeze_dried-978ff233e24dbbee308d2f60401d1bb9.png";